import { Colors, colors } from '@factorialco/deprecated-design-system'

// TODO: Change this for Gamma SM colors when we have them.
// The issue with this is that we have this information duplicated,
// since we cannot split it from the DS tokens, as they are not grouped there.
// It'd be nice to have them there under a different namespace whilst still
// being part of the `Colors` type so it behaves well with the components API
// and also having a single source of truth for its definition.
const SM_COLOR_CODES = [
  '4BC0A4', // Olive G1000
  'A2E4B0', // Apple L1000
  '83DFDA', // Teal T1000
  'EB9BFF', // Pink P1000
  'FF98C5', // Magenta M1000
  'AB9DFF', // Lavander P1000
  '7DA9FF', // Indigo I1000
  '9EE1FE', // Anakiwa C1000
  'FFA490', // Peach O1000
  'FFD788', // Pineapple Y1000
]

const nameFromHexCode = (hexCode: string): Colors => {
  return (Object.keys(colors) as (keyof typeof colors)[]).find((key) => {
    // covers both cases as param could be the hexCode or the color string
    return colors[key] === `#${hexCode}` || key === hexCode
  }) as Colors // typecasting since we are 100% sure we will find a match,
} // otherwise TS complains about the possibility of returning undefined

const hexCodeFromName = (name: Colors): string => {
  return colors[name].substring(1) // remove the hexadecimal hash (#)
}

const buildSMColorNames = (): Colors[] => SM_COLOR_CODES.map((hexCode) => nameFromHexCode(hexCode))

export { nameFromHexCode, hexCodeFromName, SM_COLOR_CODES, buildSMColorNames }
